import Image from "next/image";
import Head from "next/head";
import styles from "./optional.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import handIcon from "../../assets/images/header/touch-01.png";
// import Interest from "../../components/might-be-interest";
import downloadicon from "../../assets/images/download.png";
import NewiconA from "../../assets/images/header/pdf-download1.png";
import crashcourse from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg"; 
import Mobcrashcourse from "../../assets/images/home/Mob_Banner/UPSC-result-mobile-banner-2026.jpg";
import Link from "next/link";
import check from "../../assets/images/upsc/check.png";

const Upsc_Optional_Programme = () => {

     const feestructure3 =[


        {optional: "History",mode: "Batch I - Weekend",start: "05.07.2026",timing: "09:00 am to 01:00 pm",
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },


        {optional: "Geography",mode: "Batch I - Weekend", start: "05.07.2026", timing: "09:00 am to 01:00 pm",
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>)
            }, 

        {optional: "Psychology", mode: "Batch I - Weekend", start: "05.07.2026",timing: "09:00 am to 01:00 pm",
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },

        {optional: "Tamil Literature",mode: "Batch I - Weekend", start: "05.07.2026", timing: "09:00 am to 01:00 pm",
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },
       

        {optional: "Mathematics",mode: "Batch I - Weekend", start: "05.07.2026", timing: "08:00 am to 01:00 pm",
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>)
            },
   

        {optional: "Economics",mode: "Batch I - Weekend",start: "05.07.2026", timing: "09:00 am to 01:00 pm",
                 pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },
        {optional: "Public Administration",mode: (<><div>Batch I - Weekend </div></>) , start: "05.07.2026", timing:(<><div>09:00 am to 01:00 pm</div></>),
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>)
            }, 
        {optional: "Sociology",mode: "Batch I - Regular", start: "10.07.2026", timing: "05:00 pm to 07:30 pm",
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>)
            },
        {optional: "PSIR",mode: (<><div>Batch I - Regular</div> </>) , start: "10.07.2026", timing:(<><div>	02:30 pm to 05:00 pm</div></>),
              pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>)
            },


        {optional: "Anthropology", mode: " Batch I - Regular",start: "10.07.2026", timing: "02:30 pm to 04:30 pm",
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },

        {optional: "Agriculture",mode: "Batch I - Regular",start: "10.07.2026",timing: "06:30 pm to 08:30 pm",
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },

        {optional: "English Literature", mode: "Batch I - Regular",start: "10.07.2026",timing: "02:30 pm to 05:00 pm",
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },

        {optional: "LAW",mode: "Batch I - Regular",start: "10.07.2026",timing: "02:30 pm to 05:00 pm",
                 pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button>
                </a>),
            },

        {optional: "Forestry & Geology",mode: "",start: "After Prelims Result",timing: "",
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    {/* <button className={`${styles.normalbutton1} btn btn-danger`}>
                    Pay Now
                    </button> */}
                </a>),
            },


    ]

    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />0
            <title>UPSC Optional Programme 2026 | Shankar IAS Academy</title>
            <meta name="title" content="UPSC Optional Programme 2026 | Shankar IAS Academy" />
            <meta name="description" content=" Join Shankar IAS Academy’s UPSC Optional Programme 2026 to master your chosen subject with expert faculty guidance, personalized mentoring, and structured test series for UPSC Mains success." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-optional-programme/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC Optional Programme 2026 | Shankar IAS Academy" />
            <meta property="og:description" content="Join Shankar IAS Academy’s UPSC Optional Programme 2026 to master your chosen subject with expert faculty guidance, personalized mentoring, and structured test series for UPSC Mains success." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-optional-programme/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

    <Navbar title="upsc" />
        
    <div className="container">
        <div className="row">
            <div className="col pt-3 pt-md-2">
                <h1 className={`${styles.pagemaintitle} fw-semibold`}>UPSC Optional Programme 2026</h1>
            </div>
        </div>

        <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={crashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
        </div>

        <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={Mobcrashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
        </div> 
    </div>

    <section id="courseandfees" className="py-5 bg-light">
        <div className="container">
            <div className="mb-4 text-center text-lg-start">
              <h2 className={`${styles.sectiontitle}`}>Optional Fees and Syllabus</h2>
            </div>

            <div className={` p-4 shadow-sm rounded-3 bg-white border-start border-4 border-danger`}>
                <div className="row  g-4">  
                    <div className="col-12 col-lg-4">
                    <div>
                        <p className={`${styles.sectionsubtitle} mb-1 fw-semibold`}>Optional</p>
                        <h3 className="fw-bold text-danger mb-0">
                        ₹34,000 <small className="text-muted fs-6"></small>
                        </h3>
                    </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <a
                            href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC"
                            target="_blank"
                            rel="noreferrer"
                            className={`${styles.viewbuttonalink}`}
                        >
                            <button type="button" className={`${styles.normalbutton} px-4 py-2`}>
                            Pay Here
                            </button>
                        </a>
                    </div>

                    <div className="col-12 col-lg-4">
                        <Link href="/upsc-syllabus/#optional">
                            <button
                            className="nav-link py-1 px-2 px-0 me-4 d-flex align-items-center justify-content-center gap-1"
                            aria-controls="centre-6"
                            aria-selected="false"
                            style={{
                                backgroundColor: "#001E62",
                                color: "#fff",
                                borderRadius: "5px",
                            }}
                            >
                            UPSC Optional Syllabus
                            <Image
                                src={handIcon}
                                alt="PDF Icon"
                                width={32}
                                height={32}
                                className={styles.blinkingIcon}
                            />
                            </button>
                        </Link>
                    </div>
                </div>                
            </div>
        </div>
    </section>

    <section  id="courseandfees">
        <div className="container pt-xl-4" >
            <div className="row">
                <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#a91414" }}>Optional Subject</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Batch</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#a91414" }}>Starts on</div>
                <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Timing</div> 
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#a91414" }}>Admission</div>
                <hr/>
            </div>
                        
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Optional</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.optional}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2  pb-md-3`}>{item.mode}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2`}>{item.start}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Timing</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.timing}</div> 
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
                {item.pay}
                </div>
                <hr/>
                </div>
            ))} 
        </div>
    </section>
   
        <Footer />                      
        </>
    )
}
export default Upsc_Optional_Programme
